export const REGISTER_APPLIED_FILTER = 'REGISTER_APPLIED_FILTER';
export const ENABLE_APPLIED_FILTER = 'ENABLE_APPLIED_FILTER';
export const DISABLE_APPLIED_FILTER = 'DISABLE_APPLIED_FILTER';

export const registerAppliedFilter = (filter, name, remove, enabled) => {
    return {
        type: REGISTER_APPLIED_FILTER,
        filter,
        name,
        remove,
        enabled
    }
};

export const enableAppliedFilter = (filter) => {
    return {
        type: ENABLE_APPLIED_FILTER,
        filter
    }
};

export const disableAppliedFilter = group => {
    return {
        type: DISABLE_APPLIED_FILTER,
        group
    }
};



// WEBPACK FOOTER //
// ./src/actions/FilterGroupsActions.js